import { ref, provide, inject } from 'vue'

const CONFIGURATIONS_KEY = Symbol('configurations')

export function createConfigurationsProvider(api) {
  const configurations = ref([])
  const loading = ref(false)
  const error = ref(null)
  let inFlight = null

  const fetchConfigurations = async ({ force = false } = {}) => {
    if (!force && configurations.value.length) {
      return configurations.value
    }
    if (inFlight) {
      return inFlight
    }

    loading.value = true
    error.value = null

    inFlight = api
      .request('configurations')
      .then((response) => {
        configurations.value = response.configurations || []
        return configurations.value
      })
      .catch((err) => {
        error.value = err
        console.error('Error fetching configurations:', err)
        throw err
      })
      .finally(() => {
        loading.value = false
        inFlight = null
      })

    return inFlight
  }

  const configurationProvider = {
    configurations,
    loading,
    error,
    fetchConfigurations,
  }

  provide(CONFIGURATIONS_KEY, configurationProvider)

  return configurationProvider
}

export function useConfigurations() {
  const configurations = inject(CONFIGURATIONS_KEY)
  if (!configurations) {
    throw new Error('useConfigurations must be used within a configurations provider')
  }
  return configurations
}
